module.exports = ".status-table {\n  position: relative;\n}\n.status-table .panel {\n  overflow: auto;\n  margin-top: 20px;\n}\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/ops-support/loyalty-points/loyalty-points.component.less
// module id = 1213
// module chunks = 0